import React from 'react'
// import * as yup from 'yup'
import Checkbox from '@mui/joy/Checkbox'
import RadioGroup from '@mui/joy/RadioGroup'
import Radio from '@mui/joy/Radio'
import Grid from '@mui/joy/Grid'
import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
// import Stack from '@mui/joy/Stack'
// import Alert from '@mui/joy/Alert'
import FormControl from '@mui/joy/FormControl'
// import FormLabel from '@mui/joy/FormLabel'
import FormHelperText from '@mui/joy/FormHelperText'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import Input from '@mui/joy/Input'

import { useImmer } from 'use-immer'

// import AlertWithAutoFocus from '@newswebsiteapp/shared/react/atoms/AlertWithAutoFocus'
// import QuantityInput from '@newswebsiteapp/shared/react/atoms/QuantityInput'
import { dollarInputFormatAdapter__slotProps } from '@newswebsiteapp/shared/react/atoms/DollarInput'

// import { pluralize_verb, pluralize_noun } from '@newswebsiteapp/shared/react/utils/pluralize'

const possibleAmountsDollars = [20, 50, 100, 200, 500, 1000]

const defaultAmountsDollar = possibleAmountsDollars[0]

// .test({
//   name: 'other-or-number',
//   params: { max },
//   message: '${label} must be a number or "other"',
//   test: (value) => value == null || value.length <= max,
// }

// export const schema = yup.object().shape({
//   // amount_radioValue: yup.mixed().oneOf(['other', yup.number()], ({ label }) => `${label} must be a number or "other"`).label('Amount specifier'),
//   amount_radioValue: yup.mixed().oneOf(['other', ...possibleAmountsDollars], ({ label }) => `${label} must be a number or "other"`).label('Amount specifier'),
//   // amount_radioValue: yup.mixed().test('test', message, () => false);.label('Amount specifier'),
//   amount_otherNumber:
//     yup
//     .number()
//     .min(1)
//     .max(99999)
//     .when(
//       'amount_radioValue',
//       ([amount_radioValue], schema) => {
//         // console.log('amount_radioValue', amount_radioValue, schema)
//         return amount_radioValue === true ? schema.required() : schema.nullable()
//       }
//     )
//     .label('Amount'),
//   donationRecipient_earmarkDonation:     yup.boolean().label('Earmark donation'),
//   donationRecipient_donationRecipientId: yup
//     .number()
//     .when(
//       'donationRecipient_earmarkDonation',
//       ([donationRecipient_earmarkDonation], schema) => {
//         // console.log('donationRecipient_earmarkDonation', donationRecipient_earmarkDonation, schema)
//         return donationRecipient_earmarkDonation === true ? schema.required() : schema.nullable()
//       }
//     )
//     .label('Donation recipient id'),
//   taxReceipt_claim: yup.boolean().required().label('Claim'),
// })

function stringToIntOrThrow(input) {
  const num = parseInt(input, 10)
  if (isNaN(num)) { throw new Error(`Invalid number ${input}`) }
  return num
}

function stringToBooleanOrThrow(input) {
  if (input === 'true') { return true }
  if (input === 'false') { return false }
  throw new Error(`Invalid boolean ${input}`)
}

export const DonateNow = (args) => {
  const {
    dataFromServer,
    onSuccess,
    selectedNonDefaultDonationRecipient_id,
    // donateNowForm_state,
    // donateNowForm_updateState,
  } = args

  const [donateNowForm_state, donateNowForm_updateState] = useImmer({
    amount_radioValue: defaultAmountsDollar,
    amount_otherNumber: null, // number
    amount_otherNumber_errorMessage: null,

    donationRecipient_earmarkDonation: !!selectedNonDefaultDonationRecipient_id,
    donationRecipient_donationRecipientId: selectedNonDefaultDonationRecipient_id,
    donationRecipient_donationRecipient_errorMessage: null,

    // recurring: false,
    taxReceipt_claim: false,
  })

  console.log('DonateNow render: ', args, donateNowForm_state)

  const amount_onRadioValueChange = React.useCallback(
    (event) => {
      const value = event.target.value
      const value_numberOrOther = value === 'other' ? value : stringToIntOrThrow(value)
      donateNowForm_updateState((draft) => {
        draft.amount_otherNumber_errorMessage = null
        draft.amount_radioValue = value_numberOrOther
        if (value_numberOrOther !== 'other' && draft.amount_otherNumber === null) { draft.amount_otherNumber = value_numberOrOther }
      })
    },
    [donateNowForm_state],
  )

  const amount_onOtherNumberChange = React.useCallback(
    (event) => {
      const value = event.target.value
      donateNowForm_updateState((draft) => {
        draft.amount_otherNumber_errorMessage = null
        draft.amount_otherNumber = value === '' ? null : stringToIntOrThrow(value)
      })
    },
    [donateNowForm_state],
  )

  const donationRecipient_onEarmarkDonationChange = React.useCallback(
    (event) => {
      // console.log(event)
      // const value = event.target.checked
      donateNowForm_updateState((draft) => {
        draft.donationRecipient_donationRecipient_errorMessage = null
        draft.donationRecipient_earmarkDonation = !draft.donationRecipient_earmarkDonation
      })
    },
    [donateNowForm_state],
  )

  const donationRecipient_onDonationRecipientIdChange = React.useCallback(
    (event) => {
      const value = event.target.value
      donateNowForm_updateState((draft) => {
        // console.log(value)
        draft.donationRecipient_donationRecipient_errorMessage = null
        draft.donationRecipient_donationRecipientId = stringToIntOrThrow(value)
      })
    },
    [donateNowForm_state],
  )

  const taxReceipt_onClaimChange = React.useCallback(
    (event) => {
      const value = event.target.value
      donateNowForm_updateState((draft) => {
        // console.log(value)
        draft.taxReceipt_claim = stringToBooleanOrThrow(value)
      })
    },
    [donateNowForm_state],
  )

  const handleSubmit = React.useCallback(
    () => {
      const {
        amount_radioValue,
        amount_otherNumber,
        donationRecipient_earmarkDonation,
        donationRecipient_donationRecipientId,
        taxReceipt_claim,
      } = donateNowForm_state
      console.log('handleSubmit', donateNowForm_state)

      // const output = schema.validateSync(donateNowForm_state)
      // console.log(output)

      const amount = amount_radioValue === 'other' ? amount_otherNumber : amount_radioValue
      if (!(amount >= 1 && amount <= 99999)) {
        donateNowForm_updateState((draft) => {
          draft.amount_otherNumber_errorMessage = 'Should be a number from 1 to 99,999'
        })
        return
      }

      if (donationRecipient_earmarkDonation && !donationRecipient_donationRecipientId) {
        donateNowForm_updateState((draft) => {
          draft.donationRecipient_donationRecipient_errorMessage = 'Donation recipient is required'
        })
        return
      }

      onSuccess({
        selected_amount: amount,
        donation_recipient_id: donationRecipient_earmarkDonation ? donationRecipient_donationRecipientId : dataFromServer.default_recipient_id,
        tax_deduction: taxReceipt_claim,
        // recurring: ...
      })
    },
    [donateNowForm_state],
  )

  return (
    <>
      <Grid container justifyContent='center' alignItems='center'>
        <Typography level='h1' component='h1' mb={1} align='center' className='donate-now__header'>{dataFromServer.header_title}</Typography>
        <Typography level='h4' mb={3} align='center' className='donate-now__header'>{dataFromServer.header_title_second}</Typography>
      </Grid>

      <div className='row justify-content-center'>
        <div className='col-12 col-md-8'>
          <RadioGroup name='amount' onChange={amount_onRadioValueChange}>
            <Grid container>
              {possibleAmountsDollars.map((amount) => (
                <Grid key={amount} xs={12} lg={6} className='donate-now__radio-label-amounts'>
                  <Radio checked={donateNowForm_state.amount_radioValue === amount} value={amount} label={`$${amount}`} />
                </Grid>
              ))}
              <Grid key='other' xs={12} className='donate-now__radio-label-amounts'>
                <Radio checked={donateNowForm_state.amount_radioValue === 'other'} value='other' label='Other amount' />
              </Grid>
            </Grid>
          </RadioGroup>
        </div>
      </div>

      {donateNowForm_state.amount_radioValue === 'other' && (
        <Grid container justifyContent='center' mb={2}>
          <Grid xs={12} lg={8}>
            <FormControl required error={!!donateNowForm_state.amount_otherNumber_errorMessage}>
              <Input
                value={donateNowForm_state.amount_otherNumber || defaultAmountsDollar}
                required
                minLength={1}
                // type="number"
                // min={1}
                // min={99999}
                slotProps={dollarInputFormatAdapter__slotProps}
                onChange={amount_onOtherNumberChange}
              />
              {donateNowForm_state.amount_otherNumber_errorMessage && <FormHelperText><InfoOutlined />{donateNowForm_state.amount_otherNumber_errorMessage}</FormHelperText>}
            </FormControl>
          </Grid>
        </Grid>
      )}

      <Box mb={2}>
        <Checkbox
          label='Earmark your donation'
          checked={donateNowForm_state.donationRecipient_earmarkDonation && donateNowForm_state.donationRecipient_donationRecipientId !== null}
          indeterminate={donateNowForm_state.donationRecipient_earmarkDonation}
          onChange={donationRecipient_onEarmarkDonationChange}
        />

        {donateNowForm_state.donationRecipient_earmarkDonation && (
          <Box ml={3} mt={2}>
            <FormControl required error={!!donateNowForm_state.donationRecipient_donationRecipient_errorMessage}>
              <RadioGroup name='donation_recipient' onChange={donationRecipient_onDonationRecipientIdChange}>
                {dataFromServer.non_default_recipients.map((donationRecipient) => (
                  <Radio
                    key={donationRecipient.id}
                    checked={donateNowForm_state.donationRecipient_donationRecipientId !== null && donateNowForm_state.donationRecipient_donationRecipientId === donationRecipient.id}
                    value={donationRecipient.id}
                    label={donationRecipient.name}
                    // className="donate-now__radio-group-item"
                    sx={{ marginBlockStart: 0 }}
                  />
                ))}
              </RadioGroup>
              {donateNowForm_state.donationRecipient_donationRecipient_errorMessage && <FormHelperText><InfoOutlined />{donateNowForm_state.donationRecipient_donationRecipient_errorMessage}</FormHelperText>}
            </FormControl>
          </Box>
        )}
      </Box>

      <Checkbox label='Make this a recurring monthly payment' disabled sx={{ marginBottom: 3 }} />

      <RadioGroup defaultValue='medium' name='radio-buttons-group' onChange={taxReceipt_onClaimChange}>
        <Radio checked={donateNowForm_state.taxReceipt_claim === true} value label='Yes, I plan to claim my tax deduction for this donation to NEWSWEBSITE Foundation, a 501c3 charitable organization. Please send a tax receipt at the end of this fiscal year.' name='yes_tax' sx={{ marginBlockStart: 0 }} />
        <Radio checked={donateNowForm_state.taxReceipt_claim === false} value={false} label='No, I do not plan to report this donation to the IRS for a tax deduction. Please send a standard receipt.' name='no_tax' sx={{ marginBlockStart: 0 }} />
      </RadioGroup>

      <div className='row'>
        <button className='btn btn-warning btn-sm mx-auto' onClick={handleSubmit}>
          GIVE NOW
        </button>
      </div>
    </>
  )
}
